const excludedWords = [
  "and",
  "but",
  "or",
  "yet",
  "though",
  "however",
  "then",
  "anyway",
  "besides",
  "meanwhile",
  "therefore",
  "thus",
  "consequently",
  "if",
  "&",
  "-",
  "_",
  "/",
  "\\",
  "|",
  "!",
  "?",
  ".",
  ",",
  ";",
  ":",
];

export const getInitials = (sentence) => {
  if (!sentence) return "";

  const words = sentence
    .split(" ")
    .filter((word) => !excludedWords.includes(word.toLowerCase()));
  const initials = words
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join("");

  return initials;
};
